import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TermsConditionPopup } from "../models/terms-condition-popup.service";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from '../../shared/translate';
import { TNCAcceptanceMoment, TNCAction } from '../../shared/models/enum-helper';

@Component({
  selector: 'wego-terms-condition-accept-reject-popup',
  template: require('../views/terms-and-conditions-accept-reject-popup.component.html'),
  providers: [TermsConditionPopup,]
})

export class TermsAndConditionsAcceptRejectPopup implements OnInit {

  acceptanceMoment: TNCAcceptanceMoment;
  termsAndConditionName: any;
  bookingHashId: string;
  TotalTNC: any;
  curIndex: any;
  termsAndConditionHashId: string;
  isLoading: boolean;
  popupMsg: any;
  errorMessage: string;
  termsAndCondList: any[];
  acceptanceMomentList: TNCAcceptanceMoment[];

  @ViewChild('termsConditionModel') public termsConditionModel: ModalDirective;
  @ViewChild("childModal") public childModal: any;
  @Output('onAccept') onAccept = new EventEmitter();
  @Output('onReject') onReject = new EventEmitter();

  bodyHTMLText: string;

  constructor(
    private translate: TranslateService,
    private termsConditionPopup: TermsConditionPopup,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.popupMsg = this.translate.instant('LblSureToRevoke');
    //this.acceptanceMomentList = [TNCAcceptanceMoment.ACCOUNT_ACTIVATION];
  }

  private Confirm($event: any) {
    this.childModal.show()
  }

  private HideChildModal() {
    this.childModal.hide();
    this.hide();
  }

  public RevokeTermsAndConditions() {
    this.termsConditionPopup.RevokeTermsAndConditions(this.termsAndConditionHashId).subscribe(
      res => {
        if (res.data) {
          this.HideChildModal();
          this.hide();
          this.onAccept.emit();
        }
      },
      error => {
        this.errorMessage = error;
      }
    );
  }

  public show(acceptanceMomentList: TNCAcceptanceMoment[], bookingHashId: string = '', ctgHashId: string = '', acceptanceMoment: TNCAcceptanceMoment = TNCAcceptanceMoment.ACCOUNT_ACTIVATION) {
    this.acceptanceMomentList = acceptanceMomentList;
    this.bookingHashId = bookingHashId;
    this.acceptanceMoment = acceptanceMoment;
    this.CheckAccountActivationTermsConditionStatus();
  }

  public CheckAccountActivationTermsConditionStatus() {
    this.isLoading = true;
    this.termsConditionPopup.GetTermsConditionForDriver(this.acceptanceMomentList, this.bookingHashId).subscribe(
      res => {
        if (res.data && res.data.length == 0) {
          const isAccepted: boolean = res.data.accepted;
          this.AllConfirmed();
        } else {
          this.popupMsg = this.translate.instant('LblSureToRevoke',[res.data.type]);
          this.termsAndCondList = res.data;
          this.curIndex = 0;
          this.TotalTNC = this.termsAndCondList.length;
          this.termsAndConditionName = this.termsAndCondList[0].name;
          this.bodyHTMLText = this.termsAndCondList[0].content;
          this.termsAndConditionHashId = this.termsAndCondList[0].termsAndConditionsHashId;
          this.termsConditionModel.show();
        }

        this.isLoading = false;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnRejectClick(action: number) {
    this.ActionOnAccountActivationTermsCondition(
      this.termsAndConditionHashId,
      TNCAction.REJECTED
    );
  }

  OnAcceptClick(action: number) {
    this.ActionOnAccountActivationTermsCondition(
      this.termsAndConditionHashId,
      TNCAction.ACCEPTED
    );
  }

  public AllConfirmed() {
    this.onAccept.emit();
    this.hide();
  }

  public Rejected() {
    this.onReject.emit();
    this.hide();
  }

  public ActionOnAccountActivationTermsCondition(
    tncHashId: string,
    action: number
  ) {
    this.termsConditionPopup
      .ActionOnAccountActivationTermsCondition(tncHashId, action, this.bookingHashId, '', [this.acceptanceMoment])
      .subscribe(
        res => {
          if (action == TNCAction.ACCEPTED) {
            this.curIndex = this.curIndex + 1;
            if (this.curIndex == this.TotalTNC) {
              this.AllConfirmed();
            } else {
              this.termsAndConditionName = this.termsAndCondList[this.curIndex].name;
              this.bodyHTMLText = this.termsAndCondList[this.curIndex].content;
              this.termsAndConditionHashId = this.termsAndCondList[this.curIndex].termsAndConditionsHashId;
            }
          } else {
            this.Rejected();
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);;

        }
      );
  }


  public hide() {
    this.termsConditionModel.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsconditionpopup/components/terms-and-conditions-accept-reject-popup.component.ts